if (process.env.WEBPACK !== 'build.server') {
  module.exports = require('./client')
}
else {
  module.exports = require('./server')
}
